<template>
  <vx-card no-shadow>
    <h2 class="mb-6">Planday - Portal - General</h2>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Name</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input v-if="portal" class="w-full" v-model="portal.name" placeholder="Name" disabled />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Last Sync</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input v-if="portal" class="w-full" v-model="portal.lastSyncUtc" placeholder="Last Sync (UTC)" disabled />
      </div>
    </div>

    <vs-divider />

    <div class="vx-row mb-6">
      <vs-list v-if="portal && portal.hasWarnings">
        <vs-list-header icon="warning" title="Warnings" color="warning"></vs-list-header>
        <vs-list-item v-for="(warning, index) of portal.warnings"
          :key="index" 
          :title="'# ' + (index+1)" 
          :subtitle="warning">
        </vs-list-item>
      </vs-list>
    </div>
  </vx-card>
</template>

<script>

export default {
  data () {
    return {
      portal: null,
    }
  },
  methods: {
    getPortal: function (portalId) {
      this.$vs.loading()

      this.$http.get(process.env.VUE_APP_API +'/planday/' + portalId)
          .then(resp => {
            this.portal = resp.data

            console.log(this.portal);
          })
          .catch(err => {
            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not fetch portal:' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },
  },
  created() {
    this.getPortal(this.$route.params.portalId);
  }
}
</script>